import React from 'react'
import { Link } from 'gatsby'

const ClassInformation = ({ slice }) => {
    return (
        <section className="class-information" id="class-information">
            <div className="container">
                <div className="left-sidebar pt-100 mb-100">
                    <div>
                        <div>
                            <p className="label">Class goals</p>
                            {slice.items.map((item, index) => (
                                <div className="custom-list">
                                    <img src={item.goal_icon.url} alt={item.goal_icon.alt} className="list-icon" />
                                    <p>{item.goal.text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="mt-60">
                            <p className="label">We're here to help</p>
                            <div className="blue-box">
                                <img src={slice.primary.contact_icon.url} alt={slice.primary.contact_icon.url} />
                                <p className="blue-box-title no-margin">{slice.primary.contact_title.text}</p>
                                <p className="blue-box-text no-margin">{slice.primary.contact_text.text}</p>
                                <div className="display-flex">
                                    <Link to="/contact" className="button-inverse">{slice.primary.contact_button_text.text}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p className="label">Class overview</p>
                            <div className="white-background-box">
                                <p className="no-margin">{slice.primary.overview.text}</p>
                            </div>
                        </div>
                        <div className="mt-60">
                            <p className="label">What past students say</p>
                            <div className="white-background-box">
                                <div className="class-information-review">
                                    <img src={slice.primary.review_image.url} alt={slice.primary.review_image.url} className="full-width" />
                                    <div className="class-review-text">
                                        <p className="no-margin">{slice.primary.review_text.text}</p>
                                        <p className="mb-0 weight-bold">{slice.primary.review_name.text}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ClassInformation